module.exports = __webpack_public_path__ + "img/ខ្លាឃ្លោក.6c5d2ba2.png";